var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 24 24",
    fill: "#1c1c1c",
    id: "telegram",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-40 -40)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 40,
    y: 40,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.819,54.741L378.801,52.575C378.274,52.347 377.939,51.821 377.956,51.247C377.974,50.673 378.339,50.168 378.879,49.973C382.542,48.647 393.621,44.635 396.831,43.472C397.317,43.297 397.86,43.403 398.244,43.748C398.628,44.094 398.79,44.623 398.667,45.125C397.953,48.013 395.745,56.951 395.071,59.679C394.954,60.154 394.597,60.533 394.131,60.679C393.664,60.826 393.155,60.718 392.788,60.395L389.383,57.404L386.718,59.959C386.335,60.326 385.779,60.445 385.279,60.268C384.78,60.09 384.424,59.646 384.359,59.12L383.819,54.741ZM393.481,58.609L396.739,45.42L380.441,51.322L384.743,53.18C385.199,53.377 385.517,53.801 385.578,54.294L386.048,58.108L388.017,56.221L387.843,56.071C387.542,55.814 387.365,55.442 387.354,55.047C387.342,54.652 387.499,54.271 387.784,53.997C388.853,52.972 391.705,50.239 391.705,50.239C392.064,49.895 392.634,49.907 392.978,50.266C393.321,50.624 393.309,51.194 392.951,51.538L389.349,54.991L389.942,55.499L393.481,58.609Z",
    transform: "translate(-336.332 -.066)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.064704fcbb482efe7fd9344b46b95d80.svg";
export { ForwardRef as ReactComponent };